<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="selectItems"
    :label="$t('components.filters.OperationFilter.label')"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';
import {
  OPERATION,
  POST_FIELDS_TYPE,
  USERS_FIELDS_TYPE,
  SAC_STATUS_FIELDS_TYPE,
  SAC_SURVEYS_FIELDS_TYPE,
} from '@/services/charts-service';

import merge from 'lodash/merge';

export default {
  name: 'OperationFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
    currentField: {
      type: String,
      default: '',
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    selectItems() {
      const allItems = [{
        text: this.$t('components.filters.OperationFilter.items.sum'),
        value: OPERATION.SUM,
        type: ['continuous'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.count'),
        value: OPERATION.COUNT,
        type: ['none'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.avg'),
        value: OPERATION.AVG,
        type: ['continuous'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.min'),
        value: OPERATION.MIN,
        type: ['continuous', 'discrete'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.max'),
        value: OPERATION.MAX,
        type: ['continuous', 'discrete'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.first'),
        value: OPERATION.FIRST,
        type: ['continuous', 'discrete', 'date'],
      },
      {
        text: this.$t('components.filters.OperationFilter.items.last'),
        value: OPERATION.LAST,
        type: ['continuous', 'discrete', 'date'],
      }];

      if (!this.currentField) {
        return allItems;
      }

      const fieldType = this.getFieldType(this.currentField);
      return allItems.filter(item => item.type.includes(fieldType));
    },
  },
  methods: {
    getFieldType(field) {
      const allItems = merge({}, { none: 'none' }, POST_FIELDS_TYPE, USERS_FIELDS_TYPE, SAC_STATUS_FIELDS_TYPE, SAC_SURVEYS_FIELDS_TYPE);

      if (!field) {
        return allItems;
      }

      return allItems[field];
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}
</style>
